import { FC } from 'react';
import { StyledDislike, StyledLike, StyledLikeDislike } from './Solid.styles';
import { TypeLikeDislikeProps } from '../Types.types';
import { StyledContainer } from './Solid.styles';

export const Solid: FC<TypeLikeDislikeProps> = ({ selected, size, onChange, disabled }) => {
  return (
    <StyledContainer
      mode="ios"
      size={size}
      value={selected || 'false'}
      onIonChange={onChange}
      disabled={disabled}
    >
      <StyledLikeDislike size={size} value="false" allieColor="error-main">
        <StyledDislike selected={selected === 'false'} fontSize={size} />
      </StyledLikeDislike>
      <StyledLikeDislike size={size} value="true" allieColor="success-main" isLike>
        <StyledLike selected={selected === 'true'} fontSize={size} />
      </StyledLikeDislike>
    </StyledContainer>
  );
};
